import { render, staticRenderFns } from "./selfEmployed.vue?vue&type=template&id=ba01ea2a&scoped=true"
import script from "./selfEmployed.vue?vue&type=script&lang=js"
export * from "./selfEmployed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba01ea2a",
  null
  
)

export default component.exports